function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import partial from 'ramda/src/partial';
import pathOr from 'ramda/src/pathOr';
import clone from 'ramda/src/clone';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { validateNumbers } from 'invision-core/src/utilities/input.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import { retrieveProductsMetadata } from 'invision-core/src/components/metadata/products/products.actions';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { IsProductMetadataLoadingSelector, ProductMetadataPricingPlansByIdSelector } from 'invision-core/src/components/metadata/products/products.selectors';
import { addressHelper as AddressHelper } from 'invision-core/src/utilities/address.helper';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { SERVICE_FEATURE_ADD_ON_DESCRIPTION_OPTIMAL_CHAR_COUNT } from '../../../shared/constants/service.constants';
import { AttributeGroupsSelector, CurrentAttributeFormName, CurrentAttributesValidationStatuses, PhysicalAttributeGroupsSelector, PagesIsFetchingDataSelector, ServiceTaxCustomizationHashSelector, TelephoneNumberProvinceRegionSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import FaultCodeKeys from '../../../../api/fault.code.keys';
import { DbssShippingWarehouseIdSelector, IsQuotingOfferSelector, IsUpdatingMultiOfferShoppingCart, SelectedInventoryStoresSelector, ServiceFeaturesViewModelSelector } from '../../../../reducers/selectors/offering.order.selectors';
import { clearProductContextForServiceFeatures, getServiceFeatureProduct, retrieveProductContextForServiceFeatures, searchServiceFeatures, searchTelephoneNumberInventory, setActiveAttributeFormName, setActiveFormValidationStatus, setDeliveryDecision, setSelectedInventoryStores, updateDeliveryDecision } from '../../../../reducers/actions/offering.order.actions';
import { duplicatedServiceIdentifierAttributes } from '../../../../reducers/helpers/offer.ordering.wizard.helper';
import CareLocaleKeys from '../../../../locales/keys';
import { formValidated as setCurrentAddressAsInitialAddress, restoreMobileNumberPortabilityAttribute, saveMobileNumberPortabilityAttribute, setShowPortability, updateMobileNumberPortabilityAddressModel, validatePortInData } from '../../../../reducers/actions/mobile.number.portability.actions';
import { IsResumingCartWithMnpData, MobileNumberPortabilityAddressModelSelector, MobileNumberPortabilityAttributesSelector, MobileNumberPortabilityModelSelector, MobileNumberPortabilityShowPortabilitySelector } from '../../../../reducers/selectors/mobile.number.portability.selectors';
import { INVENTORY_LOOKUP_TYPES } from '../../../shared/constants/offering.option.status.constants';
import metadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import { DELIVERY_OPTIONS, SEARCH_INVENTORY_NO_RESULTS, SERVICE_ATTRIBUTE_DISPLAY_TYPES, SERVICE_ATTRIBUTE_TYPE } from '../../../../customercare.constants';
import { CreateEditCustomerSelector, CurrentCustomerSelector } from '../../../../reducers/selectors/customer.selectors';
import { CurrentAddressesSelector, IsFetchingAddressesSelector } from '../../../../reducers/selectors/customer.addresses.selectors';
import { retrieveCustomerAddresses } from '../../../../reducers/actions/customer.addresses.actions';
import { SelectedProducIdsOfServiceFeaturesSelectors } from '../../newConnectWizard/new.connect.wizard.selectors';
import { getFormattedServiceAttributeValue } from '../../../../reducers/selectors/services.list.selectors.helper';
import { PRICE_OVERRIDE_ACCESS } from '../../../../security.attributes';
var AttributesController = /*#__PURE__*/function () {
  function AttributesController($anchorScroll, $location, $ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, AttributesController);
    Object.assign(this, {
      $anchorScroll: $anchorScroll,
      $location: $location,
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      AddressHelper: AddressHelper,
      activeNavItem: {},
      attributesForm: null,
      // populated by ng-form
      CareLocaleKeys: CareLocaleKeys,
      billerRuleInstanceDetails: [],
      changeServiceAttributeList: this.changeServiceAttributeList.bind(this),
      closeServiceFeaturesPopup: this.closeServiceFeaturesPopup.bind(this),
      DELIVERY_OPTIONS: DELIVERY_OPTIONS,
      deliveryOptionsByPricingPlanViewModel: {},
      deliveryOptionsFieldName: i18n.translate(CareLocaleKeys.ATTRIBUTES.DELIVERY_OPTIONS),
      deliveryOptionsTooltip: require('../../../../components/shared/tooltipTemplates/deliveryOptions.tooltip.html'),
      goToNextNavItem: this.goToNextNavItem.bind(this),
      goToPreviousNavItem: this.goToPreviousNavItem.bind(this),
      INVENTORY_LOOKUP_TYPES: INVENTORY_LOOKUP_TYPES,
      mnpVerificationCallBack: this.mnpVerificationCallBack.bind(this),
      onMobileNumberPortabilityEdit: this.onMobileNumberPortabilityEdit.bind(this),
      onPhoneNumberSelection: this.onPhoneNumberSelection.bind(this),
      onPortabilityNumberChange: this.onPortabilityNumberChange.bind(this),
      onProductPricingPlansRequested: this.onProductPricingPlansRequested.bind(this),
      onDeliveryOptionsChange: this.onDeliveryOptionsChange.bind(this),
      orderScenario: undefined,
      onServiceFeaturePricingPlanSelection: this.onServiceFeaturePricingPlanSelection.bind(this),
      onTelephoneSelection: this.onTelephoneSelection.bind(this),
      billToLocationToolTipContent: i18n.translate(CareLocaleKeys.TAX_LOCATION_RULES.BILL_TO_LOCATION_TOOLTIP_CONTENT),
      originatingLocationTooltipContent: i18n.translate(CareLocaleKeys.TAX_LOCATION_RULES.ORIGINATING_LOCATION_TOOLTIP_CONTENT),
      terminatingLocationTooltipContent: i18n.translate(CareLocaleKeys.TAX_LOCATION_RULES.TERMINATING_LOCATION_TOOLTIP_CONTENT),
      productIds: [],
      searchPhones: this.searchPhones.bind(this),
      SERVICE_ATTRIBUTE_TYPE: SERVICE_ATTRIBUTE_TYPE,
      SERVICE_FEATURE_ADD_ON_DESCRIPTION_OPTIMAL_CHAR_COUNT: SERVICE_FEATURE_ADD_ON_DESCRIPTION_OPTIMAL_CHAR_COUNT,
      serviceTaxCustom: false,
      setValidationStatus: this.setValidationStatus.bind(this),
      uiNotificationService: uiNotificationService,
      updateMake: this.updateMake.bind(this),
      updateModel: this.updateModel.bind(this),
      updatePhysicalAttribute: this.updatePhysicalAttribute.bind(this),
      updateCustomizedServiceTaxValue: this.updateCustomizedServiceTaxValue.bind(this),
      validateNumbers: validateNumbers,
      serviceAttributeDisplayTypeValues: SERVICE_ATTRIBUTE_DISPLAY_TYPES
    });
  }
  return _createClass(AttributesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressStateCodesLoaded: metadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
          attributeGroups: AttributeGroupsSelector(store),
          currentAddresses: CurrentAddressesSelector(store),
          currentAttributeFormName: CurrentAttributeFormName(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentValidationStatuses: CurrentAttributesValidationStatuses(store),
          dbssShippingWarehouseId: DbssShippingWarehouseIdSelector(store),
          eligibilityModel: CreateEditCustomerSelector(store),
          isFetchingAddresses: IsFetchingAddressesSelector(store),
          isFetchingData: PagesIsFetchingDataSelector(store),
          isProductMetadataLoading: IsProductMetadataLoadingSelector(store),
          isQuotingOffer: IsQuotingOfferSelector(store),
          isRegularExpressionsLoaded: MetadataCodeLoadedSelector(CODES.RegularExpression, store),
          isResumingCartWithMnpData: IsResumingCartWithMnpData(store),
          isServiceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          isUpdatingMultiOfferShoppingCart: IsUpdatingMultiOfferShoppingCart(store),
          physicalAttributeGroups: PhysicalAttributeGroupsSelector(store),
          portabilityModel: MobileNumberPortabilityModelSelector(store),
          portabilityModelAddress: MobileNumberPortabilityAddressModelSelector(store),
          productMetadataPricingPlansBy: ProductMetadataPricingPlansByIdSelector(store),
          regularExpressions: MetadataCodeTypeDictionarySelector(CODES.RegularExpression, store),
          savedPortabilityAttributes: MobileNumberPortabilityAttributesSelector(store),
          selectedInventoryStores: SelectedInventoryStoresSelector(store),
          selectedProducIdsOfServiceFeatures: SelectedProducIdsOfServiceFeaturesSelectors(store),
          serviceAttributes: MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute, store),
          serviceFeaturesViewModel: ServiceFeaturesViewModelSelector(store),
          serviceTaxCustomizationHash: ServiceTaxCustomizationHashSelector(store),
          showPortability: !!MobileNumberPortabilityShowPortabilitySelector(store),
          telephoneCodes: TelephoneNumberProvinceRegionSelector(store),
          telephoneCodesLoaded: metadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TelephoneCodes, store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        clearProductContextForServiceFeatures: clearProductContextForServiceFeatures,
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypesThunk,
        fetchTelephoneInventory: searchTelephoneNumberInventory,
        getServiceFeatureProduct: getServiceFeatureProduct,
        restoreMobileNumberPortabilityAttribute: restoreMobileNumberPortabilityAttribute,
        retrieveCustomerAddresses: retrieveCustomerAddresses,
        retrieveProductContextForServiceFeatures: retrieveProductContextForServiceFeatures,
        retrieveProductsMetadata: retrieveProductsMetadata,
        saveMobileNumberPortabilityAttribute: saveMobileNumberPortabilityAttribute,
        searchServiceFeatures: searchServiceFeatures,
        setActiveAttributeFormName: setActiveAttributeFormName,
        setActiveFormValidationStatus: setActiveFormValidationStatus,
        setCurrentAddressAsInitialAddress: setCurrentAddressAsInitialAddress,
        setDeliveryDecision: setDeliveryDecision,
        setSelectedInventoryStores: setSelectedInventoryStores,
        setShowPortability: setShowPortability,
        updateDeliveryDecision: updateDeliveryDecision,
        updateMobileNumberPortabilityAddressModel: updateMobileNumberPortabilityAddressModel,
        validatePortInData: validatePortInData
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.mobileNumberPortabilityConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.mobileNumberPortabilityApi = api;
        }
      };
      this.telephoneSelectionConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.telephoneSelectionApi = api;
        }
      };
      this.selectServiceFeaturesPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this.selectServiceFeaturesPopupApi = api;
        }
      };
      if (this.filteredFormAttributeGroups && this.filteredFormAttributeGroups.length === 0) {
        this.setEditAttributeGroups()(this.state.attributeGroups);
      }
      this.setEditPhysicalAttributeGroups()({
        physicalAttributeGroups: this.state.physicalAttributeGroups,
        formPhysicalAttributeGroups: this.formPhysicalAttributeGroups
      });
      if (this.taxLocationOptionsByPricingPlanViewModel && Object.keys(this.taxLocationOptionsByPricingPlanViewModel).length) {
        this.updateServiceTaxLocationDecision()(this.taxLocationOptionsByPricingPlanViewModel);
      }
      Object.keys(this.state.physicalAttributeGroups).forEach(function (pricingPlanId) {
        var pricingPlan = _this.state.physicalAttributeGroups[pricingPlanId];
        pricingPlan.forEach(function (item) {
          var make, model;
          if (item.makeInformation.length === 1) {
            make = item.makeInformation[0];
          } else {
            make = item.makeInformation.length ? item.makeInformation.find(function (make) {
              return make.id === item.selectedMakeFromSavedCart;
            }) : undefined;
          }
          if (make.possibleValues.length === 1) {
            model = make.possibleValues[0];
          } else {
            model = make.possibleValues.length > 1 ? make.possibleValues.find(function (model) {
              return model.id === item.selectedModelFromSavedCart;
            }) : undefined;
          }
          if (make.possibleValues.length === 1 || make.possibleValues.length > 1 && (make || model)) {
            var selectedMakeId = make ? make.id : undefined,
              selectedModelId = model ? model.id : undefined;
            _this.updateMakeAndModel()(pricingPlanId, item.id, selectedMakeId, selectedModelId);
          }
          item.typeAttributes.forEach(function (typeAttribute) {
            if (typeAttribute.possibleValues.length === 1) {
              _this.updatePhysicalInventoryTypeAttribute()(pricingPlanId, item.id, typeAttribute.id, typeAttribute.possibleValues[0]);
            } else if (typeAttribute.selectedValue) {
              _this.updatePhysicalInventoryTypeAttribute()(pricingPlanId, item.id, typeAttribute.id, typeAttribute.selectedValue);
            }
          });
        });
      });
      this.careLocaleKeys = CareLocaleKeys;
      this.duplicatedServiceIdentifiers = [];
      this.updateMakeCallback = partial(this.updateMake).bind(this);
      this.updateModelCallback = partial(this.updateModel).bind(this);
      this.updatePhysicalAttributeCallback = partial(this.updatePhysicalAttribute).bind(this);
      this.filteredNavigationItems = this.filterNavigationItems(this.navigationItems);
      this.mnpToken = '';
      this.sendPortInData = false;
      if (!this.state.telephoneCodesLoaded) {
        this.actions.fetchCodeTypes(MetadataConstants.codes.TelephoneCodes);
      }
      if (!this.state.addressStateCodesLoaded) {
        this.actions.fetchCodeTypes(MetadataConstants.codes.AddressStateProvinceRegion);
      }
      if (!this.state.isServiceAttributesLoaded) {
        this.actions.fetchCodeTypes(CODES.ServiceAttribute);
      }
      if (!this.state.isRegularExpressionsLoaded) {
        this.actions.fetchCodeTypes(CODES.RegularExpression);
      }
      this.getInitialAddressIfAvailable();
      this.activeNavItem = this.getActiveNavItem();
      if (this.state.isResumingCartWithMnpData) {
        this.sendPortInOrItemReservation()(this.findPortableAttributeId(this.activeNavItem), true);
        this.actions.restoreMobileNumberPortabilityAttribute(this.findPortableAttributeId(this.activeNavItem));
        this.updatePortInRequest()(this.findPortableAttributeId(this.activeNavItem), this.state.portabilityModel, this.state.portabilityModel.token, this.state.portabilityModelAddress);
      }
      this.$timeout(this.setValidationStatus);
      this.actions.clearProductContextForServiceFeatures();
      this.fetchServiceAddonPricingPlanDetails();
      if (this.deliveryOptionsByPricingPlanViewModel && Object.values(this.deliveryOptionsByPricingPlanViewModel).length) {
        var firstShippablePricingPlanDeliveryDecision = Object.values(this.deliveryOptionsByPricingPlanViewModel)[0];
        var firstInstanceOfFirstShippablePricingPlanDeliveryDecision = firstShippablePricingPlanDeliveryDecision['1'];
        this.onDeliveryOptionsChange(this.selectedDeliveryDecision ? {
          selectedValue: this.selectedDeliveryDecision
        } : firstInstanceOfFirstShippablePricingPlanDeliveryDecision);
      }
      this.hasPriceOverrideAccess = hasAccess(this.state.userSecurityAttributes, PRICE_OVERRIDE_ACCESS);
    }
  }, {
    key: "updateMake",
    value: function updateMake(pricingPlanId, inventoryToUpdate, selectedOption) {
      var selectedMakeId = null !== selectedOption ? selectedOption.value : undefined;
      var selectedMakeModels = pathOr([], ['modelsByMakeId', selectedMakeId], inventoryToUpdate);
      var selectedModelId = undefined;
      if (undefined !== selectedMakeId && 1 === selectedMakeModels.length) {
        selectedModelId = selectedMakeModels[0].value;
      }
      this.updateMakeAndModel()(pricingPlanId, inventoryToUpdate.id, selectedMakeId, selectedModelId);
      this.$timeout(this.setValidationStatus);
    }
  }, {
    key: "updateModel",
    value: function updateModel(pricingPlanId, inventoryToUpdate, makeId, selectedOption) {
      this.updateMakeAndModel()(pricingPlanId, inventoryToUpdate.id, makeId, selectedOption === null ? undefined : selectedOption.value);
      this.$timeout(this.setValidationStatus);
    }
  }, {
    key: "updatePhysicalAttribute",
    value: function updatePhysicalAttribute(pricingPlanId, inventoryToUpdate, typeAttributeId, selectedOption) {
      this.updatePhysicalInventoryTypeAttribute()(pricingPlanId, inventoryToUpdate.id, typeAttributeId, selectedOption === null ? undefined : selectedOption.value);
      this.$timeout(this.setValidationStatus);
    }
  }, {
    key: "filterHidden",
    value: function filterHidden(attribute) {
      return !attribute.isHidden;
    }
  }, {
    key: "isSelectAttribute",
    value: function isSelectAttribute(attribute) {
      return !attribute.selectedValue && attribute.possibleValues && attribute.possibleValues.length;
    }
  }, {
    key: "setFormValidity",
    value: function setFormValidity(attribute) {
      this.updateAttribute()(attribute.id, attribute.formValue);
      this.$timeout(this.setValidationStatus);
    }
  }, {
    key: "setValidationStatus",
    value: function setValidationStatus() {
      var formErrors = this.getFormErrors();
      var hasErrors = this.hasErrors() || formErrors && (formErrors.patternErrors.length || formErrors.requiredErrors.length);
      this.activeNavItem = this.getActiveNavItem();
      this.actions.setActiveFormValidationStatus({
        formName: this.activeNavItem.formName,
        isValid: !hasErrors
      });
    }
  }, {
    key: "onDeliveryOptionsChange",
    value: function onDeliveryOptionsChange(deliveryDecision) {
      this.$timeout(this.setValidationStatus);
      if (deliveryDecision.selectedValue === DELIVERY_OPTIONS.SHIPPED) {
        this.actions.setSelectedInventoryStores([this.state.dbssShippingWarehouseId]);
      } else if (deliveryDecision.selectedValue === DELIVERY_OPTIONS.STORE_PICKUP && this.state.selectedInventoryStores.length && this.state.selectedInventoryStores[0] === this.state.dbssShippingWarehouseId) {
        this.actions.setSelectedInventoryStores([]);
      }
      this.actions.setDeliveryDecision(deliveryDecision.selectedValue);
      this.actions.updateDeliveryDecision(deliveryDecision.selectedValue);
    }
  }, {
    key: "selectChange",
    value: function selectChange(attribute) {
      this.setFormValidity(attribute);
    }
  }, {
    key: "radioChange",
    value: function radioChange(attribute, option) {
      this.setFormValidity(attribute);
      this.sendPortInOrItemReservation()(attribute.id, false);
      this.updateInventorySelection()(attribute.id, option, attribute.formValue);
    }
  }, {
    key: "getFormErrors",
    value: function getFormErrors() {
      var _this2 = this;
      this.hasPhysicalAttributeErrors = false;
      var errors = this.formAttributeGroups.map(function (attributeGroup) {
        return attributeGroup.formName;
      }).filter(function (formName) {
        // On initialization there are no nested forms and the remaining
        // logic is effectively short circuited with this filter
        return !!_this2.attributesForm[formName];
      }).reduce(function (errorObj, formName) {
        var formCtrl = _this2.attributesForm[formName];
        var badPatternFields = [];
        var requiredFields = [];
        if (formCtrl.$error.pattern) {
          badPatternFields = formCtrl.$error.pattern.map(function (badPatternField) {
            return badPatternField.$name;
          }).filter(function (badPatternField) {
            return formCtrl[badPatternField].$modelValue !== '' || formCtrl[badPatternField].$touched;
          });
        }
        if (formCtrl.$error.required) {
          requiredFields = formCtrl.$error.required.map(function (requiredField) {
            return requiredField.$name;
          });
        }
        return Object.assign({}, errorObj, {
          requiredErrors: errorObj.requiredErrors.concat(requiredFields),
          patternErrors: errorObj.patternErrors.concat(badPatternFields)
        });
      }, {
        requiredErrors: [],
        patternErrors: []
      });
      Object.values(this.detachedPhysicalAttributeForm || {}).forEach(function (pricingPlanValues) {
        pricingPlanValues.forEach(function (value) {
          if (value.typeAttributes && value.typeAttributes.length) {
            var requiredPhysicalAttributes = value.typeAttributes.filter(function (attribute) {
              return attribute.required;
            });
            requiredPhysicalAttributes.forEach(function (attribute) {
              if (!value.selectedTypeAttributes || !value.selectedTypeAttributes[attribute.id]) {
                _this2.hasPhysicalAttributeErrors = true;
                errors.requiredErrors.push("".concat(value.displayName, ": ").concat(attribute.name));
              }
            });
          }
          if (!value.selectedMake && value.IsRequired) {
            errors.requiredErrors.push(i18n.translate(CareLocaleKeys.ATTRIBUTES.MAKE_AND_MODEL_REQUIRED, {
              item: value.displayName
            }));
          } else if (!value.selectedModel && value.IsRequired) {
            errors.requiredErrors.push(i18n.translate(CareLocaleKeys.ATTRIBUTES.MODEL_REQUIRED, {
              item: value.displayName
            }));
          }
        });
      });
      if (this.attributesForm.serviceTaxCustomizationForm) {
        if (Object.values(this.attributesForm.serviceTaxCustomizationForm.$error).length > 0) {
          if (this.attributesForm.serviceTaxCustomizationForm['attribute-npaNxxEntry--originatingTaxLocation'] && !this.attributesForm.serviceTaxCustomizationForm['attribute-npaNxxEntry--originatingTaxLocation'].$valid || this.attributesForm.serviceTaxCustomizationForm['attribute-npaNxxEntry--terminatingTaxLocation'] && !this.attributesForm.serviceTaxCustomizationForm['attribute-npaNxxEntry--terminatingTaxLocation'].$valid || this.attributesForm.serviceTaxCustomizationForm['attribute-npaNxxEntry--billToTaxLocation'] && !this.attributesForm.serviceTaxCustomizationForm['attribute-npaNxxEntry--billToTaxLocation'].$valid) {
            errors.requiredErrors.push(i18n.translate(this.careLocaleKeys.TAX_LOCATION_RULES.NPA_NXX_ENTRY));
          }
          this.attributesForm.serviceTaxCustomizationForm.$setSubmitted(true);
        }
      }
      return errors;
    }
  }, {
    key: "changeServiceAttributeList",
    value: function changeServiceAttributeList(navItem) {
      this.$timeout(this.setValidationStatus);
      this.activeNavItem = this.getActiveNavItem();
      this.actions.saveMobileNumberPortabilityAttribute(this.findPortableAttributeId(this.activeNavItem), this.state.showPortability);
      this.actions.restoreMobileNumberPortabilityAttribute(this.findPortableAttributeId(navItem));
      this.actions.setActiveAttributeFormName(navItem.formName);
    }
  }, {
    key: "getInitialAddressIfAvailable",
    value: function getInitialAddressIfAvailable() {
      var _this3 = this;
      if (this.state.currentCustomer.Id) {
        this.actions.retrieveCustomerAddresses(this.state.currentCustomer.Id, false).then(function () {
          _this3.currentAddresses = clone(_this3.state.currentAddresses);
        }).catch(function (error) {
          _this3.uiNotificationService.transientError(error.translatedMessage);
        });
      } else {
        this.actions.updateMobileNumberPortabilityAddressModel({
          LineOne: this.state.eligibilityModel.addressLine1,
          LineTwo: this.state.eligibilityModel.addressLine2,
          Country: this.state.eligibilityModel.country,
          City: this.state.eligibilityModel.city,
          State: this.state.eligibilityModel.stateRegionProvince,
          PostalCode: this.state.eligibilityModel.postalCode
        });
      }
    }
  }, {
    key: "isAttributeFieldDuplicated",
    value: function isAttributeFieldDuplicated(id) {
      return this.attributesDuplicated().includes(id);
    }
  }, {
    key: "attributesDuplicated",
    value: function attributesDuplicated() {
      return this.duplicatedServiceIdentifiers.length ? this.duplicatedServiceIdentifiers : this.attributesDuplicatedFromServer();
    }
  }, {
    key: "attributesDuplicatedFromServer",
    value: function attributesDuplicatedFromServer() {
      return pathOr([], ['faultData'], this.lastAttemptError);
    }
  }, {
    key: "filterNavigationItems",
    value: function filterNavigationItems(navigationItems) {
      return navigationItems.length ? navigationItems.filter(function (_ref4) {
        var isHidden = _ref4.isHidden;
        return !isHidden;
      }) : [];
    }
  }, {
    key: "getActiveNavItem",
    value: function getActiveNavItem() {
      return this.filteredNavigationItems.find(function (navItem) {
        return navItem.isActive;
      });
    }
  }, {
    key: "goToPreviousNavItem",
    value: function goToPreviousNavItem() {
      this.activeNavItem = this.getActiveNavItem();
      var currentIndex = this.filteredNavigationItems.indexOf(this.activeNavItem);
      var previousNavItem = this.filteredNavigationItems[currentIndex - 1];
      this.$timeout(this.setValidationStatus);
      this.actions.saveMobileNumberPortabilityAttribute(this.findPortableAttributeId(this.activeNavItem), this.state.showPortability);
      this.actions.restoreMobileNumberPortabilityAttribute(this.findPortableAttributeId(previousNavItem));
      this.actions.setActiveAttributeFormName(previousNavItem.formName);
    }
  }, {
    key: "goToNextNavItem",
    value: function goToNextNavItem() {
      this.activeNavItem = this.getActiveNavItem();
      var currentIndex = this.filteredNavigationItems.indexOf(this.activeNavItem);
      var nextNavItem = this.filteredNavigationItems[currentIndex + 1];
      this.$timeout(this.setValidationStatus);
      this.actions.saveMobileNumberPortabilityAttribute(this.findPortableAttributeId(this.activeNavItem), this.state.showPortability);
      this.actions.restoreMobileNumberPortabilityAttribute(this.findPortableAttributeId(nextNavItem));
      this.actions.setActiveAttributeFormName(nextNavItem.formName);
    }
  }, {
    key: "getErrorForField",
    value: function getErrorForField(formName, fieldName) {
      var fieldController = this.attributesForm[formName][fieldName];
      if (fieldController.$error) {
        if (fieldController.$error.required) {
          return this.getRequiredFieldErrorMessage(fieldName);
        } else if (fieldController.$error.pattern) {
          return this.getPatternErrorMessage(fieldName);
        } else if (this.attributesDuplicatedFromServer().length && !this.duplicatedServiceIdentifiers.length) {
          // Server Validation duplicates display a specific message
          return i18n.translate(CareLocaleKeys.SERVICE_IDENTIFIER_ALREADY_EXISTS);
        } else if (this.duplicatedServiceIdentifiers.length) {
          // Local Validation duplicates display a specific message
          return i18n.translate(CareLocaleKeys.SERVICE_IDENTIFIER_UNIQUE_ERROR);
        }
      }
    }
  }, {
    key: "getRequiredFieldErrorMessage",
    value: function getRequiredFieldErrorMessage(fieldName) {
      return i18n.translate(CoreLocaleKeys.FIELD_IS_A_REQUIRED_FIELD, {
        field_name: fieldName
      });
    }
  }, {
    key: "getPatternErrorMessage",
    value: function getPatternErrorMessage(fieldName) {
      return i18n.translate(CoreLocaleKeys.FIELD_IS_INVALID, {
        field_name: fieldName
      });
    }
  }, {
    key: "getServiceIdentifierDuplicatedErrorMessage",
    value: function getServiceIdentifierDuplicatedErrorMessage() {
      return i18n.translate(CareLocaleKeys.SERVICE_IDENTIFIER_DUPLICATES_FOUND, {
        duplicates: this.attributesDuplicated().length
      });
    }
  }, {
    key: "shouldShowErrors",
    value: function shouldShowErrors() {
      return !!(this.wizardForm.$submitted && (this.attributesForm.$invalid || this.attributesDuplicated().length || this.hasPhysicalAttributeErrors) || this.attributesDuplicatedFromServer().length);
    }
  }, {
    key: "hasErrors",
    value: function hasErrors() {
      return this.attributesForm.$invalid;
    }
  }, {
    key: "shouldShowFieldError",
    value: function shouldShowFieldError(formName, fieldName, id) {
      var fieldController = this.attributesForm[formName][fieldName];
      if (this.attributesForm[formName][fieldName]) {
        return fieldController.$error.required && (fieldController.$touched || this.wizardForm.$submitted) || fieldController.$modelValue && fieldController.$error.pattern || this.isAttributeFieldDuplicated(id);
      }
      return false;
    }
  }, {
    key: "getMoreOptions",
    value: function getMoreOptions(attribute) {
      this.searchAttributeInventory()(attribute);
    }
  }, {
    key: "onPortabilityNumberChange",
    value: function onPortabilityNumberChange(attribute) {
      this.activeNavItem = this.getActiveNavItem();
      this.actions.setShowPortability(this.state.showPortability);
      this.updateAttribute()(attribute.id, this.showPortInOrItemRsvp(attribute));
      this.sendPortInOrItemReservation()(attribute.id, this.sendPortInData);
      if (this.sendPortInData && this.state.isResumingCartWithMnpData) {
        this.sendPortInOrItemReservation()(attribute.id, true);
        this.actions.restoreMobileNumberPortabilityAttribute(this.findPortableAttributeId(this.activeNavItem));
        this.updatePortInRequest()(attribute.id, this.state.portabilityModel, this.state.portabilityModel.token, this.state.portabilityModelAddress);
      }
    }

    // Please note - because this is an exceptional situation with nested
    // dynamically generated forms its less error prone to keep this form
    // in sync the Angular way than the Redux way.
    // See https://confluence.csgicorp.com/display/Ascendon/Redux#Redux-DynamicAngularforms
    // for more information
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _this4 = this;
      var formAttributeGroups = pathOr(null, ['formAttributeGroups', 'currentValue'], changesObj) || this.formAttributeGroups;
      var filteredFormAttributeGroups = pathOr(null, ['filteredFormAttributeGroups', 'currentValue'], changesObj);
      if (filteredFormAttributeGroups && filteredFormAttributeGroups.length) {
        this.duplicatedServiceIdentifiers = duplicatedServiceIdentifierAttributes(formAttributeGroups);
        // Performs a simple/shallow clone
        this.detachedFormObj = this.filteredFormAttributeGroups.map(function (attributeGroupVM) {
          return Object.assign({}, attributeGroupVM);
        });
        // There's an assumption that form groups and attributes in those groups
        // will never change order at runtime
        this.detachedFormObj.forEach(function (attributeGroup, index) {
          var sourceGroup = _this4.filteredFormAttributeGroups[index];
          // Rather than blowing away the reference, use the original attribute
          // reference and replace the three values we care about
          attributeGroup.attributes.forEach(function (attribute, attrIndex) {
            var sourceAttribute = sourceGroup.attributes[attrIndex];
            attribute.formValue = sourceAttribute.formValue;
            attribute.isHidden = sourceAttribute.isHidden;
            attribute.inventoryItemReservation = sourceAttribute.inventoryItemReservation;
          });
        });
        if (changesObj.filteredFormAttributeGroups.previousValue.length) {
          this.handleServiceFeaturesIfServiceIdentifierChanged(changesObj.filteredFormAttributeGroups);
        }
      }
      if (changesObj.filteredPhysicalAttributeGroups) {
        this.detachedPhysicalAttributeForm = Object.assign({}, this.filteredPhysicalAttributeGroups);
      }
      if (changesObj.navigationItems) {
        this.filteredNavigationItems = this.filterNavigationItems(this.navigationItems);
      }
      if (changesObj.deliveryOptionsByPricingPlan) {
        this.deliveryOptionsByPricingPlanViewModel = clone(changesObj.deliveryOptionsByPricingPlan.currentValue);
      }
      if (changesObj.taxLocationOptionsByPricingPlan) {
        this.taxLocationOptionsByPricingPlanViewModel = clone(changesObj.taxLocationOptionsByPricingPlan.currentValue);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.setActiveAttributeFormName(this.state.currentAttributeFormName);
      this.disconnectRedux();
    }
  }, {
    key: "onMobileNumberPortabilityEdit",
    value: function onMobileNumberPortabilityEdit(attribute) {
      var _this5 = this;
      this.activeNavItem = this.getActiveNavItem();
      if (this.sendPortInData && this.state.isResumingCartWithMnpData) {
        this.actions.restoreMobileNumberPortabilityAttribute(this.findPortableAttributeId(this.activeNavItem));
        this.sendPortInOrItemReservation()(attribute.id, true);
        this.updatePortInRequest()(attribute.id, this.state.portabilityModel, this.state.portabilityModel.token, this.state.portabilityModelAddress);
      }
      this.mobileNumberPortabilityApi.open(attribute);
      this.onMobileNumberPortabilityVerificationComplete = function (addressData, portabilityData) {
        _this5.sendPortInOrItemReservation()(attribute.id, true);
        _this5.actions.saveMobileNumberPortabilityAttribute(attribute.id, _this5.state.showPortability);
        _this5.updateAttribute()(attribute.id, _this5.state.portabilityModel.existingNumber);
        _this5.updatePortInRequest()(attribute.id, portabilityData, _this5.mnpToken, addressData);
      };
    }
  }, {
    key: "mnpVerificationCallBack",
    value: function mnpVerificationCallBack(addressData, portabilityData, inventoryTypeId) {
      var _this6 = this;
      this.showMnpLoadingIndicator = true;
      this.actions.validatePortInData(addressData, portabilityData, inventoryTypeId, this.state.currentCustomer.Id).then(function (response) {
        if (response.Token) {
          _this6.mnpToken = response.Token;
          _this6.showMnpLoadingIndicator = false;
          _this6.mobileNumberPortabilityApi.showConfirmation(response.Token, null);
        }
      }).catch(function (error) {
        _this6.sendPortInData = false;
        _this6.showMnpLoadingIndicator = false;
        if (error.faultCode !== FaultCodeKeys.INVALID_PORT_IN_REQUEST_LAMBDA_ERROR) {
          _this6.mobileNumberPortabilityApi.showConfirmation(false, error.translatedMessage);
        }
      });
    }
  }, {
    key: "showPortInOrItemRsvp",
    value: function showPortInOrItemRsvp(attribute) {
      var currentForm = this.state.savedPortabilityAttributes[attribute.id];
      if (currentForm && this.state.showPortability) {
        this.sendPortInData = true;
        return currentForm.portabilityModel.existingNumber;
      } else if (!currentForm && this.state.showPortability) {
        this.sendPortInData = true;
        return null;
      } else {
        this.sendPortInData = false;
        return attribute.selectedValue;
      }
    }
  }, {
    key: "findPortableAttributeId",
    value: function findPortableAttributeId(formName) {
      var portableAttribute = this.formAttributeGroups.filter(function (item) {
        return item.formName === formName.id;
      });
      var mnpAttribute = portableAttribute[0].attributes.find(function (attribute) {
        return attribute.isPortable;
      });
      if (mnpAttribute) {
        return mnpAttribute.id || null;
      }
    }
  }, {
    key: "onTelephoneSelectionPopup",
    value: function onTelephoneSelectionPopup(attribute) {
      var _this7 = this;
      // phoneSelectionAttribute used to reference attribute when opening the modal since .open() does accept parameters
      this.phoneSelectionAttribute = attribute;
      this.isTelephoneSelectionOpen = true;
      this.telephoneNumberSelected = null;
      this.telephoneList = null;
      this.$timeout(function () {
        _this7.telephoneSelectionApi.open();
      });
    }
  }, {
    key: "onTelephoneSelection",
    value: function onTelephoneSelection(attribute, phoneNumber) {
      this.isTelephoneSelectionOpen = false;
      this.telephoneSelectionApi.close();
      if (attribute && phoneNumber) {
        attribute.formValue = phoneNumber.SerialNumber;
        this.radioChange(attribute, phoneNumber);
      }
      this.telephoneList = null;
    }
  }, {
    key: "formatPhoneNumber",
    value: function formatPhoneNumber(attribute) {
      return getFormattedServiceAttributeValue(attribute.serviceAttributeId, attribute.formValue, this.state.serviceAttributes, this.state.regularExpressions);
    }
  }, {
    key: "onPhoneNumberSelection",
    value: function onPhoneNumberSelection(phoneNumber) {
      this.telephoneNumberSelected = phoneNumber;
    }
  }, {
    key: "searchPhones",
    value: function searchPhones(searchPatterns) {
      var _this8 = this;
      this.actions.fetchTelephoneInventory(this.phoneSelectionAttribute.inventoryTypeId, searchPatterns).then(function (response) {
        _this8.telephoneList = response.InventoryItems;
      }).catch(function (error) {
        _this8.telephoneList = [];
        if (error.faultCode !== SEARCH_INVENTORY_NO_RESULTS) {
          _this8.uiNotificationService.transientError(error.translatedMessage);
        }
      });
    }

    //Service Features
  }, {
    key: "closeServiceFeaturesPopup",
    value: function closeServiceFeaturesPopup() {
      this.selectServiceFeaturesPopupApi.close();
      this.serviceFeaturesOpen = false;
    }
  }, {
    key: "getServiceFeatureAttribute",
    value: function getServiceFeatureAttribute(data) {
      return data[0].attributes.find(function (attribute) {
        return attribute.isServiceFeatureAvailable;
      }) || {};
    }
  }, {
    key: "handleServiceFeaturesIfServiceIdentifierChanged",
    value: function handleServiceFeaturesIfServiceIdentifierChanged(_ref5) {
      var currentValue = _ref5.currentValue,
        previousValue = _ref5.previousValue;
      var currentService = this.getServiceFeatureAttribute(currentValue);
      var previousService = this.getServiceFeatureAttribute(previousValue);
      if (previousService.id && previousService.serviceFeatures && previousService.serviceFeatures.length && currentService.instanceNumber === previousService.instanceNumber && currentService.pricingPlanId === previousService.pricingPlanId && currentService.id !== previousService.id) {
        previousService.serviceFeatures.forEach(function (serviceFeature) {
          serviceFeature.ServiceAttributeId = currentService.serviceAttributeId;
        });
        this.updateSelectedServiceFeatures()(currentService.id, previousService.serviceFeatures);
        this.updateSelectedServiceFeatures()(previousService.id, []);
      }
    }
  }, {
    key: "getMappedServiceFeatures",
    value: function getMappedServiceFeatures(serviceFeatures) {
      var _this9 = this;
      var serviceAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var skipCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var modifiedServiceFeature = [];
      var currentServiceFeatures = [];
      this.billerRuleInstanceDetails = [];
      serviceFeatures.forEach(function (serviceFeature) {
        if (!skipCheck) {
          currentServiceFeatures = _this9.detachedFormObj[0].serviceFeatures.filter(function (existingServiceFeature) {
            return serviceFeature.pricingPlanId === existingServiceFeature.pricingPlanId && serviceFeature.productId === existingServiceFeature.productId;
          });
        }
        if (serviceFeature.quantity && serviceFeature.quantity > 1 && !skipCheck) {
          for (var i = 0; i < serviceFeature.quantity; i++) {
            if (serviceFeature.billerRuleDetails && serviceFeature.billerRuleDetails.length) {
              serviceFeature.billerRuleDetails.forEach(function (billerRuleDetail) {
                _this9.billerRuleInstanceDetails.push({
                  BillerRuleConfigurationId: billerRuleDetail.BillerRuleConfigurationId,
                  ServiceFeatureProductId: serviceFeature.productId,
                  ServiceFeaturePricingPlanId: serviceFeature.pricingPlanId,
                  BillerRuleDecisionDetails: [billerRuleDetail]
                });
              });
            }
            modifiedServiceFeature.push({
              PricingPlanId: serviceFeature.pricingPlanId,
              PricingPlanName: serviceFeature.pricingPlanName,
              ProductId: serviceFeature.productId,
              ProductName: serviceFeature.productName,
              ServiceAttributeId: serviceAttribute.serviceAttributeId || serviceFeature.serviceAttributeId,
              ServiceId: serviceAttribute.serviceId || serviceFeature.serviceId,
              ServiceInstanceId: serviceAttribute.serviceInstanceId || pathOr(undefined, ['serviceInstanceId'], _this9.getServiceFeatureAttribute(_this9.detachedFormObj)),
              //Service Instance Id  is required to associate the SF to a service if the service exists
              SubscriberProductId: currentServiceFeatures[i] ? currentServiceFeatures[i].subscriberProductId : undefined,
              BillerRuleDetails: serviceFeature.billerRuleDetails
            });
          }
          ;
        } else {
          if (serviceFeature.billerRuleDetails && serviceFeature.billerRuleDetails.length) {
            serviceFeature.billerRuleDetails.forEach(function (billerRuleDetail) {
              _this9.billerRuleInstanceDetails.push({
                BillerRuleConfigurationId: billerRuleDetail.BillerRuleConfigurationId,
                ServiceFeatureProductId: serviceFeature.productId,
                ServiceFeaturePricingPlanId: serviceFeature.pricingPlanId,
                BillerRuleDecisionDetails: [billerRuleDetail]
              });
            });
          }
          modifiedServiceFeature.push({
            PricingPlanId: serviceFeature.pricingPlanId,
            PricingPlanName: serviceFeature.pricingPlanName,
            ProductId: serviceFeature.productId,
            ProductName: serviceFeature.productName,
            ServiceAttributeId: serviceAttribute.serviceAttributeId || serviceFeature.serviceAttributeId,
            ServiceId: serviceAttribute.serviceId || serviceFeature.serviceId,
            ServiceInstanceId: serviceAttribute.serviceInstanceId || pathOr(undefined, ['serviceInstanceId'], _this9.getServiceFeatureAttribute(_this9.detachedFormObj)),
            //Service Instance Id  is required to associate the SF to a service if the service exists
            SubscriberProductId: serviceFeature.subscriberProductId || undefined,
            BillerRuleDetails: serviceFeature.billerRuleDetails
          });
        }
      });
      return modifiedServiceFeature;
    }
  }, {
    key: "openServiceFeaturesPopup",
    value: function openServiceFeaturesPopup() {
      var _this10 = this;
      this.orderScenario = this.getServiceFeatureAttribute(this.detachedFormObj).parentServicePlanOrderScenario;
      this.serviceFeaturesOpen = true;
      this.actions.searchServiceFeatures(this.detachedFormObj[0].attributes[0].serviceId, this.state.currentCustomer.Id, this.segmentationContext).then(function () {
        _this10.$timeout(function () {
          _this10.selectServiceFeaturesPopupApi.open();
        });
      }).catch(function (error) {
        _this10.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onProductPricingPlansRequested",
    value: function onProductPricingPlansRequested(productId) {
      this.actions.retrieveProductContextForServiceFeatures(productId, this.detachedFormObj[0].attributes[0].serviceId, this.state.currentCustomer.Id, this.orderScenario);
      this.actions.getServiceFeatureProduct(productId, this.state.currentCustomer.Language);
    }
  }, {
    key: "onServiceFeaturePricingPlanSelection",
    value: function onServiceFeaturePricingPlanSelection(serviceFeatures) {
      this.productIds = [];
      var serviceAttribute = this.getServiceFeatureAttribute(this.detachedFormObj);
      this.updateSelectedServiceFeatures()(serviceAttribute.id, this.getMappedServiceFeatures(serviceFeatures, serviceAttribute), this.billerRuleInstanceDetails);
      this.restoreOfferingContext()();
      this.fetchServiceAddonPricingPlanDetails();
      this.closeServiceFeaturesPopup();
    }
  }, {
    key: "removeServiceFeature",
    value: function removeServiceFeature(serviceFeature) {
      var _this11 = this;
      var selectedServiceFeatures = clone(this.detachedFormObj[0].serviceFeatures);
      var indexOfServiceFeatureToRemove = selectedServiceFeatures.findIndex(function (selectedServiceFeature) {
        if (selectedServiceFeature.productId === serviceFeature.productId && selectedServiceFeature.pricingPlanId === serviceFeature.pricingPlanId) {
          return _this11.addItems && _this11.addItems.length ? !selectedServiceFeature.subscriberProductId : true;
        }
        ;
      });
      selectedServiceFeatures.splice(indexOfServiceFeatureToRemove, 1);
      this.updateSelectedServiceFeatures()(serviceFeature.attributeId, this.getMappedServiceFeatures(selectedServiceFeatures), this.billerRuleInstanceDetails, true);
      this.restoreOfferingContext()();
    }
  }, {
    key: "fetchServiceAddonPricingPlanDetails",
    value: function fetchServiceAddonPricingPlanDetails() {
      var _this12 = this;
      if (this.state.selectedProducIdsOfServiceFeatures.length) {
        this.actions.retrieveProductsMetadata(this.state.selectedProducIdsOfServiceFeatures).catch(function (error) {
          _this12.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "updateCustomizedServiceTaxValue",
    value: function updateCustomizedServiceTaxValue(customizedServiceTax) {
      this.updateServiceTaxLocationDecision()(customizedServiceTax);
    }
  }, {
    key: "setAttributeVisibilityBasedOnServiceAttribute",
    value: function setAttributeVisibilityBasedOnServiceAttribute(allowEdit, serviceAttributeDisplayCode) {
      if (allowEdit && !serviceAttributeDisplayCode) {
        return this.serviceAttributeDisplayTypeValues.EDITABLE;
      }
      if (!allowEdit && serviceAttributeDisplayCode && String(serviceAttributeDisplayCode) !== this.serviceAttributeDisplayTypeValues.HIDDEN) {
        return this.serviceAttributeDisplayTypeValues.VIEWABLE;
      }
      return serviceAttributeDisplayCode && String(serviceAttributeDisplayCode);
    }
  }]);
}();
export default {
  template: require('./attributes.html'),
  controller: AttributesController,
  controllerAs: 'attributesController',
  bindings: {
    addItems: '<',
    attributeFormSubmitted: '<',
    attributeTitle: '<',
    deliveryOptionsByPricingPlan: '<',
    filteredFormAttributeGroups: '<',
    filteredPhysicalAttributeGroups: '<',
    formAttributeGroups: '<',
    formPhysicalAttributeGroups: '<',
    isFeaturesHidden: '<?',
    showCustomizeTaxOption: '<?',
    lastAttemptError: '<',
    navigationItems: '<',
    restoreOfferingContext: '&?',
    searchAttributeInventory: '&',
    segmentationContext: '<?',
    selectedDeliveryDecision: '<?',
    sendPortInOrItemReservation: '&',
    setEditAttributeGroups: '&',
    setEditPhysicalAttributeGroups: '&',
    showNextButton: '<',
    showPreviousButton: '<',
    taxLocationOptionsByPricingPlan: '<?',
    updateAttribute: '&',
    updateInventorySelection: '&',
    updateMakeAndModel: '&',
    updatePhysicalInventoryTypeAttribute: '&',
    updatePortInRequest: '&',
    updateSelectedServiceFeatures: '&',
    updateServiceTaxLocationDecision: '&?'
  },
  require: {
    wizardForm: '^form'
  }
};